import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const BookingPage = lazy(() => import('../pages/booking/page'));
const NewsPage = lazy(() => import('../pages/news/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const ResourcesPage = lazy(() => import('../pages/resources/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Service Pages
const DiabetesHypertensionPage = lazy(() => import('../pages/services/diabetes-hypertension/page'));
const DietNutritionPage = lazy(() => import('../pages/services/diet-nutrition/page'));
const MentalWellnessPage = lazy(() => import('../pages/services/mental-wellness/page'));
const PreventiveCarePage = lazy(() => import('../pages/services/preventive-care/page'));
const LifestyleCoachingPage = lazy(() => import('../pages/services/lifestyle-coaching/page'));
const IntegrativeMedicinePage = lazy(() => import('../pages/services/integrative-medicine/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/resources',
    element: <ResourcesPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/booking',
    element: <BookingPage />,
  },
  {
    path: '/services/diabetes-hypertension',
    element: <DiabetesHypertensionPage />,
  },
  {
    path: '/services/diet-nutrition',
    element: <DietNutritionPage />,
  },
  {
    path: '/services/mental-wellness',
    element: <MentalWellnessPage />,
  },
  {
    path: '/services/preventive-care',
    element: <PreventiveCarePage />,
  },
  {
    path: '/services/lifestyle-coaching',
    element: <LifestyleCoachingPage />,
  },
  {
    path: '/services/integrative-medicine',
    element: <IntegrativeMedicinePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
